import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './public/inc/Navbar/Navbar';
import Footer from './public/inc/Footer/Footer';
import LandingPage from './public/Landing_page/Landing_page';
import Login from './public/Login/Login';
import SignUp from './public/SignUp/SignUp';
import Men from './public/men/Men';
import Women from './public/women/Women';
import Product from './public/Product/Product';
import CustomerDashboard from './public/Dashboard/Dashboard';

import Dashboard from './admin/Dashboard/Dashboard';
import Customers from './admin/Customers/Customers';
import Products from './admin/Products/Products';
import Orders from './admin/Orders/Orders';
import Appointments from './admin/Appointments/Appointments';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Admin Routes - Χωρίς Navbar/Footer του public site */}
          <Route path="/admin" element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          } />
          <Route path="/admin/customers" element={
            <AdminRoute>
              <Customers />
            </AdminRoute>
          } />
          <Route path="/admin/products" element={
            <AdminRoute>
              <Products />
            </AdminRoute>
          } />
          <Route path="/admin/orders" element={
            <AdminRoute>
              <Orders />
            </AdminRoute>
          } />
          <Route path="/admin/appointments" element={
            <AdminRoute>
              <Appointments />
            </AdminRoute>
          } />
          
          {/* Public Routes */}
          <Route path="*" element={
            <>
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/men" element={<Men />} />
                  <Route path="/women" element={<Women />} />
                  <Route path="/products" element={<Product />} />
                  <Route path="/dashboard" element={<CustomerDashboard />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
